<template>
    <div>
        <HeaderSys></HeaderSys>

        <div class="carousel">
            <div>
                <el-carousel
                    :interval="5000"
                    arrow="always"
                >
                    <el-carousel-item
                        v-for="(item, index) in bannerList"
                        :key="index"
                    >
                        <img
                            class="scroll_item"
                            :src="item.IMGURL"
                            alt=""
                            @click="applynow"
                        />
                    </el-carousel-item>
                </el-carousel>
            </div>

            <div class="login-parent">
                <LoginInfoCard></LoginInfoCard>
            </div>
        </div>

        <div
            class="in_center"
            id="applyNow"
        >
            <!-- <div @click="quickChannel" style="width: 415px;height:70px;margin: 0 auto;background-image: url('//images/quick.png');background-repeat: no-repeat;background-size: cover;background-position: center;cursor: pointer;margin-top: 50px;"></div> -->
            <div
                class="title"
                @click="quickChannel"
            >
                <span>电子投标保函快速办理通道</span>
                <span class="sub">点击进入</span>
            </div>

            <h3 class="sub-title">全流程在线办理</h3>
            <p class="desc">3分钟办理 最快24小时出函 顺丰邮寄</p>

            <PriceComputer @apply="applynow"></PriceComputer>
        </div>

        <div class="references">
            <div class="in_center">

                <h3 class="title">关联机构</h3>
                <ul class="list">
                    <li
                        v-for="(item, index) in imgList"
                        :key="index"
                    >
                        <img
                            :src="item.IMGURL"
                            alt=""
                        />
                    </li>
                </ul>
            </div>
        </div>

        <DialogBhType v-model="selectGuaranteeDialogStatus"></DialogBhType>

        <FooterSys></FooterSys>
    </div>
</template>

<script>
import PAGE_MIXIN from '@mixins/page.js';

import DialogBhType from '@components/sys/dialog-bh-type.vue';
import HeaderSys from '@components/sys/header-sys';
import FooterSys from '@components/sys/footer-sys';

import LoginInfoCard from '@/branch/bhtong/index/sections/login-info-card.vue';

import PriceComputer from './components/price-computer.vue';

export default {
    mixins: [PAGE_MIXIN],
    components: {
        HeaderSys,
        FooterSys,
        DialogBhType,
        LoginInfoCard,
        PriceComputer,
    },
    data() {
        return {
            bannerList: [],
            imgList: [],

            selectGuaranteeDialogStatus: false,
        };
    },
    methods: {
        applynow() {
            window.location.assign('#applyNow');
        },
        applyBhNew() {
            this.selectGuaranteeDialogStatus = true;
        },
        quickChannel: function () {
            if (
                !this.$store.getters['userinfo/loginStatus'] ||
                !window.sessionStorage.getItem('mobile')
            ) {
                this.$message({
                    message: '请先登录',
                    type: 'warning',
                });
                return;
            }

            sessionStorage.setItem('chjg', 'dbjg');
            sessionStorage.setItem('bhlx', 'tbbh');

            window.location.href = '/web/all/all.html?earnest=';
        },
    },
    mounted() {
        this.$get(
            `${this.$store.state.api.baseUrl}/webinfo/adlist`,
            { adtype: '1' },
            (data) => {
                this.bannerList = data;
            }
        );

        this.$get(
            `${this.$store.state.api.baseUrl}/webinfo/adlist`,
            { adtype: '2' },
            (data) => {
                this.imgList = data;
            }
        );
    },
};
</script>

<style lang="scss" scoped>
.in_center {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
}

.carousel {
    position: relative;

    ::v-deep {
        .el-carousel__container {
            height: 460px;
        }
        .el-carousel__arrow {
            border-radius: 0;
        }
    }

    .login-parent {
        width: 1200px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;

        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .scroll_item {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%);
        cursor: pointer;
    }
}

#applyNow {
    .title {
        background-image: linear-gradient(to right, #fb9c3d, #f48a40);
        width: 30%;
        height: 65px;
        margin: 0 auto;
        line-height: 65px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: white;
        border-radius: 50px;
        margin-top: 50px;
        cursor: pointer;

        .sub {
            background-color: rgb(255, 242, 229);
            color: #f48a40;
            font-size: 15px;
            padding: 0 6px;
            border-radius: 12px;
            display: inline-block;
            line-height: 23px;
            position: relative;
            top: -1px;
            margin-left: 4px;
        }
    }

    .sub-title {
        margin-top: 34px;
        text-align: center;
        font-size: 32px;
        margin-bottom: 10px;
    }

    .desc {
        text-align: center;
        font-size: 22px;
        color: #858789;
        margin-bottom: 1em;
    }
}

.references {
    background-color: #f5f6f7;
    overflow: hidden;

    .title {
        margin-top: 50px;
        text-align: center;
        font-size: 32px;
    }

    .list {
        overflow: hidden;
        margin-bottom: 60px;

        li {
            float: left;
            width: 222px;
            border: 1px solid #d5dade;
            height: 80px;
            margin: 5px 5px;

            img {
                width: 220px;
                height: 77px;
            }
        }
    }
}

a {
    color: #6c6c6c;
}
</style>